import { PluginBankStatementsBrokerRequest } from '../../../types/plugins';
import { buildHeadersFromDocumentParams } from '../../documents/logic/buildHeadersFromDocumentParams';
import { DocumentParams } from '../../documents/types/DocumentParams';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const runBankStatementsBrokerRequest = (
  constructPost: ConstructPost,
  data: PluginBankStatementsBrokerRequest,
  documentParams: DocumentParams,
): Promise<NonPaginatedResponse<null> | undefined> =>
  constructPost<NonPaginatedResponse<null>>(
    `${PLUGIN_BASE_PATH}/bank-statements-broker-request`,
    { data, headers: buildHeadersFromDocumentParams(documentParams) },
    { preventDefaultErrorToast: true },
  );
